import {Actions, Mutations} from "@/store/enum/StoreEnums";

export default {
    state: () => ({
        breadcrumbs: {},
        tabsRouter: ''
    }),
    getters: {
        tabsRouter(state) {
            return state.tabsRouter;
        },

        getBreadcrumbs(state) {
            return state.breadcrumbs;
        },

        pageBreadcrumbPath(state) {
            return state.breadcrumbs.pageBreadcrumbPath;
        },

        pageTitle(state) {
            return state.breadcrumbs.title;
        }
    },
    actions: {
        [Actions.SET_BREADCRUMB_ACTION](state, payload) {
            state.commit(Mutations.SET_BREADCRUMB_MUTATION, payload);
        },
        [Actions.SET_TABS_ROUTER](state, payload) {
            state.commit(Mutations.SET_TABS_ROUTER, payload);
        }
    },
    mutations: {
        [Mutations.SET_BREADCRUMB_MUTATION](state, payload) {
            state.breadcrumbs = payload;
        },
        [Mutations.SET_TABS_ROUTER](state, payload) {
            state.tabsRouter = payload;
        }
    }
};